module.exports = __webpack_public_path__ + "static/media/ic_calendar.55a98504.svg";